<template>
<!-- Sections -->
<section id="mod-intro" :class="['pt-page','pt-page-2','mod-intro',
    meanList[1].clicked ? 'pt-page-current' : '',
    meanList[1].leave ? 'pt-page-moveToTop pt-page-current':'',
    meanList[1].enter ? 'pt-page-scaleUp':'']"><!-- Webpartzones --><!-- Webparts -->
<div class="mod-section-intro content-container">
  <h2><span class="first"><span class="active"><span>Web（3YEARS/ING）</span></span></span><span class="second"><span class="active"><span class="anim">Java（1YEAR）</span></span></span></h2>
  <p class="infoText anim">
    经历：企业后台管理、定制网站网页、IPTV平板、微信公众号、微信小程序。<br>
    应用及框架：MySQL、Spring、SpringMVC、Hibernate、JQuery、Sea、Cordova、Zepto、Vue。<br>
    接触过：SVN、Java、JavaScript、HTML、CSS、Hexo、Coding、GitHub、阿里云、七牛云
  </p>
  <p class="infoText_2 anim">
    我喜欢coding，但不专注于当专家级别，我想要的是宽度而不是深度。
  </p>
  <div class="button-wrapper anim">
    <a href="https://www.vmartaw.com/zcc/2017/02/09/2017%E5%B9%B4%E6%AF%8F%E4%B8%80%E4%B8%AA%E4%B8%8D%E6%9B%BE%E8%B5%B7%E8%88%9E%E7%9A%84%E6%97%A5%E5%AD%90%E9%83%BD%E6%98%AF%E5%AF%B9%E7%94%9F%E5%91%BD%E7%9A%84%E8%BE%9C%E8%B4%9F/" class="cta button" target="_blank"><span>每一个不曾起舞的日子都是对生命的辜负</span></a>
  </div>
  <div class="award anim">
  </div>
</div>
</section>
</template>

<script>
export default {
  props:['pageBoolean','meanList'],
  data(){
    return{
      progressWidth:{
        width:0
      },
      pageText:{
        time:0,
      },
      currentBoolean:{
        isFullPlay:false,
        toggleFullPlay:false,
        toggleFullPlayMuted:false
      }
    }
  },
  methods:{
    canplay(){
      var video=document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad=false;
      video.style.width=window.innerWidth+'px';
      video.play();
    },
    toggleFullPlay(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay=!this.currentBoolean.toggleFullPlay;
      if(this.currentBoolean.toggleFullPlay){
        this.progressBarVal();
        fullVideo.pause();
      }else{
        fullVideo.play();
      }
    },
    toggleFullPlayMuted(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted=!this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted=this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=false;
      this.currentBoolean.toggleFullPlay=false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal(){
      var fullVideo=document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time=this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width=(fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar(e){
      var fullVideo=document.getElementById('fullVideo'),fullBar=document.getElementById('fullBar'),
      precent=(e.clientX/fullBar.clientWidth).toFixed(5),currentTime=0;
      currentTime=fullVideo.duration*precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime=currentTime;
      //console.log(currentTime);
    },
    showTime(time){
      var timeStr="";
      if(time < 10){
        timeStr="0:0"+time;
      }else if(time < 60){
        timeStr="0:"+time;
      }else{
        if(time % 60 < 10){
          timeStr=Math.floor(time/60)+":0"+time % 60;
        }else{
          timeStr=Math.floor(time/60)+":"+time % 60;
        }
      }
      return timeStr;
    }
  }
}
</script>



// WEBPACK FOOTER //
// Intro.vue?65ec66f6